import { defineNuxtPlugin } from '#imports'

export default defineNuxtPlugin({
    name: 'composable-api:context',
    setup: (nuxtApp) => {
        const $composableApi = {}
        Object.defineProperty(nuxtApp, '$composableApi', { get: () => $composableApi })
    },
})
